import { Box, Divider, Grid, Stack, Typography, useTheme } from "@mui/material";
import { customerContactBusiness } from "api/bussiness/customer/customer-contact-bussiness";
import { CustomerPermission } from "commons/enum/permission";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import {
  IContactInformation,
  IContactInformationProperties,
} from "mobx-stores/_models/customers/contact-information";

import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import {
  EditIconButton,
  RemoveIconButton,
} from "share-components/mui-wrap/button/action-button";
type ContactsProps = {
  contactInformations: IContactInformation[];
};
export const Contacts = observer(({ contactInformations }: ContactsProps) => {
  return (
    <Grid container spacing={2} marginBottom={"20px"}>
      {contactInformations.map((x, idx) => (
        <Grid item key={x.id}>
          <ContactInfo contact={x}></ContactInfo>
        </Grid>
      ))}
    </Grid>
  );
});
type ContactProps = {
  contact: IContactInformationProperties;
};
const ContactInfo = observer(({ contact }: ContactProps) => {
  const {
    customerManagement: {
      contactManagement: { setProp: setContactManagementProps },
      getCustomerDetail,
      customerDetail,
    },
    deleteConfirmationStore: { setProp, setDeletionCallback },
  } = useStores();
  const theme = useTheme();
  const onRemoveClick = useCallback(() => {
    setProp("open", true);
    setDeletionCallback(async () => {
      if (contact.id) {
        await customerContactBusiness.delete(contact.id);
        if (customerDetail?.id) {
          await getCustomerDetail(customerDetail?.id);
        }
      }
    });
  }, [
    contact.id,
    customerDetail?.id,
    getCustomerDetail,
    setDeletionCallback,
    setProp,
  ]);

  const onEditClicked = useCallback(() => {
    setContactManagementProps("openEdit", true);
    setContactManagementProps("selectdContact", cloneDeep(contact));
  }, [contact, setContactManagementProps]);
  return (
    <Stack
      direction={"column"}
      justifyContent={"flex-start"}
      spacing={2}
      sx={{
        minWidth: "300px",
        height: "180px",
        borderRadius: "12px",
        padding: "10px 10px",
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography
          component={"div"}
          fontWeight={theme.typography.fontWeightMedium}
          textAlign={"center"}
        >
          {contact.departmentType?.name || ""}
        </Typography>
        <Box>
          <RemoveIconButton
            accessPermission={[CustomerPermission.Delete]}
            onClick={onRemoveClick}
          ></RemoveIconButton>
          <EditIconButton
            accessPermission={[CustomerPermission.Update]}
            onClick={onEditClicked}
          ></EditIconButton>
        </Box>
      </Stack>
      <Divider></Divider>
      <Stack flex={1} justifyContent={"center"}>
        <Grid container spacing={1}>
          <Grid item xs={3}>
            <Typography variant="subtitle2" sx={{ opacity: 0.8 }}>
              Tên
            </Typography>
          </Grid>
          <Grid item xs={9}>
            {contact.fullName || ""}
          </Grid>

          <Grid item xs={3}>
            <Typography variant="subtitle2" sx={{ opacity: 0.8 }}>
              Email
            </Typography>
          </Grid>
          <Grid item xs={9}>
            {contact.email}
          </Grid>

          <Grid item xs={3}>
            <Typography variant="subtitle2" sx={{ opacity: 0.8 }}>
              Điện thoại
            </Typography>
          </Grid>
          <Grid item xs={9}>
            {contact.phoneNumber}
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
});
